import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "play",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18.095 18.095"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  id: "Tracé_1085",
  "data-name": "Tracé 1085",
  d: "M12.647,21.695A9.047,9.047,0,1,0,3.6,12.647,9.047,9.047,0,0,0,12.647,21.695Zm-.5-12.25a1.131,1.131,0,0,0-1.759.941v4.524a1.131,1.131,0,0,0,1.759.941l3.393-2.262a1.131,1.131,0,0,0,0-1.882L12.144,9.445Z",
  transform: "translate(-3.6 -3.6)",
  fill: "#fff",
  "fill-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}